import { graphql } from '../../../gql';

export const GET_USER_BY_USERNAME_QUERY = graphql(`
  query getUserByUsername($username: String!) {
    getUserByUsername(username: $username) {
      id
      username
      reputation {
        overallScore
        vouchBoost
        confidence
        source
        lastUpdated
        domains
        dimensionScores { engagement consistency diversityInclusivity behavioralAnalysis communityImpact contentQuality innovativeness expertise }
        dimensionConfidences { engagement consistency diversityInclusivity behavioralAnalysis communityImpact contentQuality innovativeness expertise }
        evidence { engagement consistency diversityInclusivity behavioralAnalysis communityImpact contentQuality innovativeness expertise }
      }
    }
  }
`);
